export default __webpack_public_path__ + "static/media/반려식물 화분 클래스 web.956a7507.jpg";